/**
 * 指定された16進数形式のカラーコードのコントラストを確保するための文字色を返す
 * @param {string} hexColor - 16進数形式のカラーコード（#FFFFFF または #FFF）
 * @returns {string} コントラストを確保するための文字色（黒か白）
 */
export const getContrastColor = (hexColor: string): string => {
  // 3文字の16進カラーコードを6文字に展開する
  if (hexColor.length === 4) {
    hexColor = `#${hexColor[1]}${hexColor[1]}${hexColor[2]}${hexColor[2]}${hexColor[3]}${hexColor[3]}`
  }
  // 16進カラーコードをRGBに変換する
  const r = parseInt(hexColor.slice(1, 3), 16)
  const g = parseInt(hexColor.slice(3, 5), 16)
  const b = parseInt(hexColor.slice(5, 7), 16)
  // RGB値から相対輝度を計算する（単純な方法）
  const brightness = (r * 299 + g * 587 + b * 114) / 1000
  // 輝度が160以上なら文字色は黒、未満なら白
  return brightness >= 160 ? '#333333' : '#FFFFFF'
}
